<template>
  <div class='h-dialogContainer'>
    <template>
      <BaseBusiness :formParams='formParamsBase' :reMountPage='reMount' ref="base" :opCode="opCode"></BaseBusiness>
    </template>
    <SubTabs :elements="tabs.elements" :styles='tabs.styles'>
      <template v-slot:tabsContent>
        <div style="margin-top: 15px;">
          <VoiceBusiness :formParams='formParamsVoice' :reMountPage='reMount' ref="voice" :opCode="opCode"></VoiceBusiness>
        </div>
        <div style="margin-top: 15px;">
          <DataBusiness :formParams='formParamsData' :reMountPage='reMount' ref="data" :opCode="opCode"></DataBusiness>
        </div>
        <div style="margin-top: 15px;">
          <VideoBusiness :formParams='formParamsVideo' :reMountPage='reMount' ref="video" :opCode="opCode"></VideoBusiness>
        </div>
      </template>
    </SubTabs>
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.eleQryVpnInfo' :styles='dialog.stylesWithIndex'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata" :disableNodes="disableNode"></OrganizationalTree>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness';
import VoiceBusiness from '../U_VoiceBusiness';
import DataBusiness from '../U_DataBusiness';
import VideoBusiness from '../U_VideoBussiness';
import SubTabs from '../../../../subscriberconfig/util/SubTabs';
import SubscriberTool from '../../../../subscriberconfig/util/parseFormNew/tools/subscriberTool';
import commonJs from '../../common';
import CustomDialog from '../../../../common/CustomDialog';
import OrganizationalTree from '../../OrganizationalTree';

export default {
  name: 'AddGroupDialog',
  components: {
    SubTabs,
    BaseBusiness,
    VoiceBusiness,
    DataBusiness,
    VideoBusiness,
    CustomDialog,
    OrganizationalTree
  },
  mixins: [commonJs],
  props: [
    'opCode',
    'neid'
  ],
  methods: {
    mainHandler(data = []) {
      const $this = this;
      let arrBase = null;
      let arrVioce = null;
      let arrData = null;
      let arrVideo = null;
      const params = {
        msgid: this.msg.addGroup,
        neid: this.neid,
        serviceType: 'microPoc'
      };
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', params)
        .then((response) => {
          const res = response.data.resultVal;
          const sub = new SubscriberTool();
          this.initAnotherBusiness(res, data);
          const resultMap = sub.$devideByGroupBy(res, data);
          // this.initAnotherBusinessDatas(data);
          arrBase = resultMap.get($this.formParamsBase.modelName);
          $this.formParamsBase = arrBase;

          arrVioce = resultMap.get($this.formParamsVoice.modelName);
          $this.formParamsVoice = arrVioce;

          arrData = resultMap.get($this.formParamsData.modelName);
          $this.formParamsData = arrData;

          arrVideo = resultMap.get($this.formParamsVideo.modelName);
          $this.formParamsVideo = arrVideo;

          //修改时，vpnid支持修改
          if (data && data.length === undefined) {
            try{
              const vpntree = $this.$parent.$parent.$refs.eleModGroup.$parent.$parent.$parent.$parent.$refs.organizationalTree;
              $this.vpndata = vpntree.initData;
              $this.disableNode = vpntree.disableNode;
            } catch (e) {
              console.log('获取组织架构失败了');
            }
            setTimeout(() => {
              $this.bindClickAfterPageCreated();
            }, 200);
          }
        });
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false
        ? false : (this.$refs.voice.validateResult() === false
          ? false : (this.$refs.data.validateResult() === false
            ? false : (this.$refs.video.validateResult() === false
              ? false : true)));
      if (this.getDatasAnotherControl() === false) {
        return false;
      }
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const map = this.$refs.base.getDatas();
      //vpnId重新赋值
      this.vpnId && map.set('vpnId', this.vpnId);
      const mapVoice = this.$refs.voice.getDatas();
      const mapData = this.$refs.data.getDatas();
      const mapVideo = this.$refs.video.getDatas();
      const returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVoice).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapData).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVideo).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      const opCount = returnObj.opCount;
      const gpArr = [];
      if (this.opCode === '0') {
        for (let i = 0; i < opCount; i++) {
          gpArr.push('sip:' + (parseInt(returnObj.groupId) + i) + '@group.' + this.enterpriseDomain);
        }
      } else {
        gpArr.push(returnObj.groupId);
      }
      returnObj.groupId = gpArr;
      returnObj.groupLevel = 1;
      return returnObj;
    },
    getDatasAnotherControl() {
      const baseDatas = this.$refs.base.getDatas();
      if (baseDatas.get('groupType') === 2 && baseDatas.get('areaFlag') === 0) {
        this.$toast('warning', this.$t('MCS.nozonegrp'));
        return false;
      }
    },
    initAnotherBusiness(res, data) {
      switch (this.opCode) {
        case '-1':
          this.initCommonBusiness(res);
          break;
        case '0':
          this.initCommonBusiness(res);
          break;
        case '1':
          // 动态组不可修改
          if (parseInt(data.groupType) === 1) {
            res.forEach((item) => {
              if(item.name === 'groupType' || item.name === 'groupOwner')
              item.readonly = true;
            });
          } else {
            this.initCommonBusiness(res);
          }
          break;
        case '2':
          this.initCommonBusiness(res);
          break;
        default:
      }
    },
    initCommonBusiness(res) {
      res.forEach((item) => {
        switch (item.name) {
          case 'groupType':
            if (item.options !== undefined || item.options.length !== 0) {
              for (let i = 0; i < item.options.length; i++) {
                if (item.options[i].value === 1) { // 动态组
                  item.options.splice(i, 1);
                  break;
                }
              }
            }
            break;
          default:
        }
      });
    },

    reMount() {
      this.$refs.base.reMount();
      this.$refs.voice.reMount();
      this.$refs.data.reMount();
      this.$refs.video.reMount();
    },
    bindClickAfterPageCreated() {
      // 输入框点击事件----根据name名称找到组件
      const componentArray = this.$refs.base.$children[0].$children;
      console.log(componentArray)
      componentArray.forEach(item => {
        if (item.$refs.vpnId) {
          // 输入框右侧增加"选择超链接"
          const input = document.createElement('A');
          input.onclick = this.getVpnInfo;
          input.className = 'h-subscriber-atag';
          const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
          input.appendChild(valueOfAtag);
          item.$refs.vpnId.parentElement.className = 'h-subscriber-div-innerwitha';
          item.$refs.vpnId.parentElement.appendChild(input);
          return null;
        }
        return null;
      });
    },
    /**
     * 组织架构列表查询
     * @param propinfo
     * @param res
     * @returns {*}
     */
    getVpnInfo(propinfo, $this) {
      // 组织架构查询赋值
      this.$refs.qryVpnInfoPage.show();
      console.log('vpndata', this.vpndata);
      this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
      this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
    },
    /**
     * 更新和关闭组织架构
     */
    setChooseVpnInfo(event) {
      if (event.keyCode === 13) {
        return;
      }
      const selectNode = this.$refs.organizationalTreeInner.getNode();
      if (!selectNode) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        this.$toast('warning', this.$t('SubscriberIms.chooseNodeTip'));
      } else if(selectNode.id.split('_')[2] === '0' || selectNode.id.split('_')[2] === 0) {
        //不允许修改到根节点
        this.$toast('warning', this.$t('MCS.vpn0CantAddGroup'));
      } else {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
        // this.$refs.base.$refs.bus.setData('vpnId', selectNode.text);
        this.vpnId = selectNode.id.split('_')[2];
        this.$refs.base.$refs.bus.setData('vpnId', this.vpnId);
        this.$refs.base.$refs.bus.validateResult(['vpnId']);
      }
    },
    closeQryVpnInfoPage() {
      this.$refs.organizationalTreeInner.clear();
      this.$refs.qryVpnInfoPage.clear();
      this.$refs.qryVpnInfoPage.close();
    }
  },
  data() {
    return {
      groupType: "1",
      tabs: {
        elements: {
          refName: 'xxxxx',
          items: [
            { header: this.$t('MCS.voiceBusiness'), contentKey: 'item1-content' },
            { header: this.$t('MCS.dataBusiness'), contentKey: 'item2-content' },
            { header: this.$t('MCS.videoBusiness'), contentKey: 'item3-content' },
          ]
        },
        styles: {
          heightMode: 'Auto'
        }
      },
      formParamsBase: {
        json: '',
        formId: this.opCode + 'baseBusinessGms',
        subObject: '',
        modelName: 'base',
      },
      formParamsVoice: {
        json: '',
        formId: this.opCode + 'voiceBusinessGms',
        subObject: '',
        modelName: 'voice',
      },
      formParamsData: {
        json: '',
        formId: this.opCode + 'dataBusinessGms',
        subObject: '',
        modelName: 'data',
      },
      formParamsVideo: {
        json: '',
        formId: this.opCode + 'videoBusinessGms',
        subObject: '',
        modelName: 'video',
      },
      dialog: {
        eleQryVpnInfo: {
          target: this.$refs.qryVpnInfoPage,
          refName: 'qryVpninfo',
          buttonGroup: [
            { click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }},
            { click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }}],
          title: this.$t('SubscriberIms.organization'),
          isClose: true
        },
        stylesWithIndex: {width: '20%', height: '48%',visible: false,model: true, zIndex: 1000,},
      },
      vpndata: [],
      disableNode:[],
      vpnId: undefined
    };
  },
};
</script>
